import { isAxiosError } from 'axios';

/** Transient tutor/network failures — not auth failures. */
export function isTemporaryTutorNetworkError(error: unknown): boolean {
  if (error == null) return false;

  if (isAxiosError(error)) {
    const status = error.response?.status;
    if (status === 401 || status === 403) return false;
    if (status === 502 || status === 503 || status === 504) return true;
    if (!error.response) return true;
    const code = String(error.code || '');
    if (code === 'ERR_NETWORK' || code === 'ECONNABORTED' || code === 'ERR_CONNECTION_REFUSED') {
      return true;
    }
    return false;
  }

  if (error instanceof TypeError) {
    const msg = String(error.message || '').toLowerCase();
    return (
      msg.includes('failed to fetch') ||
      msg.includes('network') ||
      msg.includes('load failed')
    );
  }

  const msg = String((error as { message?: string })?.message || error).toLowerCase();
  return (
    msg.includes('failed to fetch') ||
    msg.includes('network error') ||
    msg.includes('connection refused') ||
    msg.includes('connection reset') ||
    msg.includes('502') ||
    msg.includes('503') ||
    msg.includes('504')
  );
}
